import { makeStyles, createStyles, lighten } from '@material-ui/core/styles'
import type { Theme } from '@material-ui/core/styles'

export const useChipStyles = makeStyles<Theme, { color: string }>(() =>
  createStyles({
    chip: {
      color: ({ color }) => color,
      borderColor: ({ color }) => color
    },

    deleteIcon: {
      color: ({ color }) => color,

      '&:hover': {
        color: ({ color }) => lighten(color, 0.3)
      }
    }
  })
)
